<template>
  <div>
    <el-form :model="searchForm" class="search-form">
      <el-form-item label="" prop="dateTime">
        <el-date-picker v-model="dateTime" type="daterange" range-separator="-" start-placeholder="开始日期"
          end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="changeTime"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="fansIdOrName">
        <el-input :maxlength="255" v-model="searchForm.fans" placeholder="达人昵称/用户ID" />
      </el-form-item>
      <el-form-item label="" prop="dateTime">
        <el-date-picker v-model="searchForm.payTime" type="date" placeholder="选择结佣时间" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd" :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>

      <!-- 操作按钮 -->
      <el-form-item>
        <!-- 操作按钮 -->
        <el-button type="warning" @click="onFormSearch">查询</el-button>
        <el-button type="warning" plain @click="onFormReset">重置</el-button>
        <el-button @click="onFormExport">导出数据</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格-->
    <el-table header-row-class-name="header" border highlight-current-row :data="table.dataSource"
      v-loading="table.loading">
      <el-table-column label="数据日期" min-width="180" prop="dataDateStr">
      </el-table-column>
      <el-table-column min-width="180" label="达人" prop="itemdateTimeStr">
        <template slot-scope="{ row }">
          <div class="table-user">
            <img :src="row.headImage
              ? row.headImage
              : require('../../../../assets/img/default_img.png')
              " />
            <div class="table-user__right">
              <div>{{ row.fansNickName }}</div>
              <div>用户ID：{{ row.fansId }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="结佣订单" min-width="180" prop="accountStr">
        <template slot-scope="{ row }">
          <div>订单数：{{ row.settledCnt }} 个</div>
          <div>订单金额：{{ row.settledAmount }}元</div>
        </template>
      </el-table-column>
      <el-table-column label="结佣金额" min-width="180" prop="accountStr">
        <template slot-scope="{ row }">
          <span clas="color-red">{{ row.settledCommission }}</span>
        </template>
      </el-table-column>

      <el-table-column label="结佣时间" prop="payTimeStr" min-width="180">
        <template slot-scope="{ row }">
          <span>{{ row.payTimeStr }}</span>
          <span v-if="row.payType === 1">（{{ row.payTypeStr }}）</span>
        </template>
      </el-table-column>

    </el-table>
    <!-- 分页-->
    <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
      @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total" />
  </div>
</template>

<script>
import douYin from "@/javaApi/douyin";

const DouYinModel = new douYin();

const searchParams = {
  payTime: "", // 结佣时间
  dataBeginTime: "", // 开始日期
  dataEndTime: "", // 结束日期
  // 搜素表单
  fans: "", // 粉丝ID或者名称
};
export default {
  props: {
    activeName: {
      // 激活名称
      type: String,
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      dateTime: [], // 日期
      searchForm: Object.assign({}, searchParams),
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      table: {
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
    };
  },
  watch: {
    activeName: {
      immediate: true,
      handler: async function () {
        if (this.activeName === "second") {
          this.freshTable();
        }
      },
    },
  },
  methods: {
    // 改变日期
    changeTime(arr) {
      if (arr && arr.length) {
        this.searchForm.dataBeginTime = arr[0];
        this.searchForm.dataEndTime = arr[1];
      } else {
        this.searchForm.dataBeginTime = "";
        this.searchForm.dataEndTime = "";
      }
    },

    // 表单搜素
    onFormSearch() {
      this.pagination.pageNo = 1;
      this.freshTable();
    },
    // 表单重置`
    onFormReset() {
      this.dateTime = [];
      this.searchForm = Object.assign({}, searchParams);
      this.pagination.pageSize = 10;
      this.onFormSearch();
    },
    // 转换数据
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + m + d;
    },
    // 导出
    onFormExport() {
      DouYinModel.alreadyEngagedExport(this.searchForm).then((res) => {
        const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        console.log("blob", blob);
        let url = window.URL.createObjectURL(blob);
        console.log("url", url);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = window.URL.createObjectURL(blob);
        a.download = "已结佣" + this.formatDate(new Date()) + ".xls";
        a.click();
        window.URL.revokeObjectURL(url);
        this.$message({
          message: "导出成功",
          type: "success",
        });
      });
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 请求表格·
    async freshTable() {
      this.table.loading = true;
      const data = await DouYinModel.getAlreadyEngagedPage({
        ...this.pagination,
        ...this.searchForm,
      }).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        this.table.dataSource = data.data.data.list;
        this.table.total = data.data.data.total;
      }
    },
  },
};
</script>

<style scoped lang="less">
// 表格样式
.table {
  &-user {
    display: flex;

    &>img {
      width: 32px;
      height: 32px;
      object-fit: fill;
      border-radius: 50%;
    }

    &__right {
      margin-left: 8px;

      &>div:first-child {
        font-size: 13px;
        line-height: 18px;
      }

      &>div:last-child {
        font-size: 12px;
        color: #666666;
        line-height: 17px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/distribution/AlreadyEngaged.vue